"use client";

import type { FC } from "react";
import { Provider } from "react-redux";

import { Container } from "@jti/core-components/components/Container";
import { AppModelProvider, LanguagesProvider, store, UserAuth as App } from "@jti/user-auth";

import { mapUserAuthOptionsToAppModel } from "@/components/UserAuth/mapUserAuthOptionsToAppModel";
import { useLanguages } from "@/hooks/useLanguages";

import type { userAuthInputs } from "./UserAuth.builder";

export type UserAuthProps = BuilderComponentProps<typeof userAuthInputs>;

export const UserAuth: FC<UserAuthProps> = (options) => {
  const languages = useLanguages();

  const userAuthAppModel = mapUserAuthOptionsToAppModel(options);

  return (
    <Container>
      <LanguagesProvider model={languages}>
        <AppModelProvider model={userAuthAppModel}>
          <Provider store={store}>
            <App />
          </Provider>
        </AppModelProvider>
      </LanguagesProvider>
    </Container>
  );
};
